module.exports = __webpack_public_path__ + "b806c87147d2a94810a6ab3798db4c49.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00003ASH.png
// module id = 1516
// module chunks = 0